import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import BubbleGetter from "../../Components/BubbleGetter/BubbleGetter";
import "../../Styles/App.css";
import { saveApiToken, getApiToken, removeApiToken, saveCurrentUser, removeCurrentUser } from "../../Features/LocalStorage/LocalStorageUtility";
import axiosInstance from "../../Services/AxiosAPICaller";

const BubbleListPage: React.FC = () => {

  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      window.scrollTo(0, 0);
      
      var currentToken = getApiToken();
  
      if (currentToken && currentToken.trim() !== "") {
        try {
          var MeAndRole = await axiosInstance.get('/users/me');
          console.log('Me object with role =', MeAndRole.data);
        } catch (error) {
          console.error('unknown Token / or API Error', error);
          removeApiToken();
          removeCurrentUser();
          window.location.reload();
        }
      }
  
      const params = new URLSearchParams(location.search);
      const token = params.get('loginToken');
  
     if (token) {
        try {
          const response = await axiosInstance.get<{ jwt: string, user: any, context: any }>('/passwordless/login?loginToken=' + token);
          const { jwt, user } = response.data;
  
          if (!currentToken || (currentToken && currentToken !== jwt)) {
            saveApiToken(jwt);
          } else {
            console.log('Token is already found in local storage');
          }
          saveCurrentUser(user);
        } catch (error) {
          console.error('Error while trying to login with token:', error);
        }
  
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
        window.location.reload();
      }
    };

    fetchData();
  }, [location]);


  return <BubbleGetter />;

}

export default BubbleListPage;
